<template>
  <v-card class="confirm-combo">
    <v-card-title>
      <v-row>
        <v-col class="d-flex align-center">
          <p v-if="offerCombo.length === 1" class="mb-0">{{ offerComboArray.length }} combo:</p>
          <p v-else>{{ offerComboArray.length }} combos:</p>
        </v-col>
        <v-col>
          <mf-search v-model="search" class="pa-0 ma-0 ml-3" hide-details placeholder="Busque um combo" @input="filterProducts" />
        </v-col>
      </v-row>
    </v-card-title>

    <v-card-text class="pa-0">
      <v-expansion-panels v-if="offerComboArray.length" v-model="panel" multiple>
        <v-expansion-panel v-for="(offerCombo, index) in offerComboArray" :key="index" class="expansion-panel">
          <v-expansion-panel-header class="expansion-header">
            <v-img v-if="offerCombo.image" :src="offerCombo.image" class="expansion-header-img" contain />
            <div v-else class="expansion-header-img d-flex align-center justify-center">
              <mf-icon> image_not_supported </mf-icon>
            </div>

            <span class="expansion-header-title">{{ offerCombo.name.length ? offerCombo.name : 'Combo sem nome' }}</span>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <products-on-offer-combo-cards
              :offer-combo="offerCombo"
              :id-key="index"
              status-campaign="active"
              :eans="eans"
              :validations="$v"
              offer-sales-key-name="combo_offer_sales"
              second-offer-sales-key-name="target_products"
              disabled-fields
              disable-export
              is-revision
            />
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
      <v-row v-else class="py-5" justify="center" align="center">
        <p class="mb-0 texto-corrido">Não há dados</p>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import ProductsOnOfferComboCards from '../offer-combo/ProductsOnOfferComboCards.vue'
import { required, requiredIf, minValue, numeric, integer } from 'vuelidate/lib/validators'
import { notOnlySpace } from '@/helpers/validators.js'
import { eansValidation } from '../../../helpers/validators'
import { cloneDeep } from 'lodash'

export default {
  name: 'ConfirmCampaignOfferComboTable',
  components: {
    ProductsOnOfferComboCards: ProductsOnOfferComboCards,
  },
  props: {
    eans: {
      type: Object,
      required: true,
    },
    offerCombo: {
      type: Array,
      default: () => [],
    },
    extraHeaders: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    search: '',
    productsLocal: [],
    expanded: [],
    panel: [],
  }),
  computed: {
    allSingleProducts() {
      return this.offerCombo.reduce((accumulator, current) => {
        if (current.products) {
          const productsGroup = current.products.map((product) => {
            const { products, __typename, ...productWithoutGroup } = current

            return { ...productWithoutGroup, ...product }
          })
          accumulator.push(...productsGroup)
        } else {
          accumulator.push(current)
        }

        return accumulator
      }, [])
    },
    offerComboArray() {
      const formattedArray = this.search !== '' ? cloneDeep(this.productsLocal) : cloneDeep(this.offerCombo)

      return formattedArray.map((combo) => {
        combo.trigger_products = combo.trigger_products.reduce((accumulator, product) => {
          if (product.isGroup) {
            const formattedProducts = product.products.map((item) => {
              const { isGroup, product: productDetail, ...formattedProduct } = item
              const { _id } = productDetail

              return Object.assign(formattedProduct, { quantity: product.quantity, _id, product: productDetail })
            })

            accumulator.push(...formattedProducts)
          } else {
            accumulator.push(product)
          }

          return accumulator
        }, [])
        return combo
      })
    },
  },
  methods: {
    filterProducts(searchKey) {
      let arrayOfMatchedObjects = this.allSingleProducts.filter((object) => {
        return JSON.stringify(object).toString().toLowerCase().includes(searchKey.toLowerCase())
      })
      this.productsLocal = searchKey !== '' ? arrayOfMatchedObjects : []
    },
  },
  validations() {
    return {
      offerComboArray: {
        $each: {
          name: { required },
          maximum_per_client: { required },
          trigger_products: {
            required,
            $each: {
              sku: requiredIf(function (group) {
                return !group.products
              }),
              name: { required, notOnlySpace },
              quantity: { minValue: minValue(1), integer },
              eans: {
                eansValidation,
              },
              products: {
                $each: {
                  eans: {
                    eansValidation,
                  },
                  name: { required, notOnlySpace },
                },
              },
            },
          },
          target_products: {
            required,
            $each: {
              sku: requiredIf(function (group) {
                return !group.products
              }),
              name: { required, notOnlySpace },
              percentage_discount: { minValue: minValue(1), numeric },
              eans: {
                eansValidation,
              },
              products: {
                $each: {
                  eans: {
                    eansValidation,
                  },
                  name: { required, notOnlySpace },
                },
              },
            },
          },
        },
      },
    }
  },
}
</script>

<style lang="scss" scoped>
.confirm-combo {
  .row-width {
    width: 300px;
  }
}
::v-deep .v-expansion-panel {
  padding: 12px 24px;
  &--active {
    padding: 12px 24px 24px;
  }
  &-content__wrap {
    padding: 0 !important;
  }
  &-header {
    &--active {
      border-bottom: 1px solid $cinza-l80;
    }
    &__icon {
      padding-right: 16px;
    }
  }
}
.expansion-header {
  display: flex;
  column-gap: 16px;
  padding: 0;
  &-img {
    max-width: 40px;
    height: 40px;
  }
  &-title {
    font-family: 'Lato';
    font-weight: 400;
    font-size: 18px;
    color: $cinza-d10;
  }
}
</style>
